import {STATE} from "../classes/Enum";
import '../styles/footer.css';
import { useSearch, useCart, useAppState } from "./Context";
import { getDescription, getTitle } from "../helper/main";
import { useAuth } from "./AuthProvider";

function FooterComponent({ isMobile, selectedItem, setState, toggleMenu, scrolled }) {
  const { state } = useAppState();
  const {cart, setCart} = useCart();
  const {setQuery} = useSearch();
  const { user } = useAuth();

  const goToTop = () => window.scrollTo(0, 0);

  const getCartCount = () => {
    if (cart.length > 0) {
    return cart.reduce((total, item) => total + item.count, 0);
    }
  }

  if (selectedItem) {
    return;
  }


  const isAdminPage = state === STATE.ADMIN_TOOLS;

  return (
    <div className={`glue ${scrolled ? 'min' : ''} ${isAdminPage ? 'admin-mode' : ''}`}>
      <div className={`footer ${scrolled ? 'min' : ''}`}>
              { isMobile && (
        <div className="row footer-logo-container">
          <div className="footer-logo">
            {/* <img  src="/logo192.png" alt="Logo" /> */}
            <h1 className="gradient-text">Collect</h1><h1 className="brand-div-text">Div</h1>
          </div>
        </div>
        )}
        { !isMobile && (
          <div className="footer-logo shiny">
            <img  src="/logo192.png" alt="Logo" />
            <h1 className="gradient-text">Collect</h1><h1 className="brand-div-text">Div</h1>
          </div>
        )}
          <div className={`footer-button-container ${state === STATE.OVERVIEW ? 'is-active' : ''}`} onClick={() => { goToTop(); setState(STATE.OVERVIEW); setQuery("");}}>
            {<h2 className={`footer-button-text`}>Home</h2>}
          </div>

          <div className={`footer-button-container ${state === STATE.SEALED ? 'is-active' : ''}`} onClick={() => { goToTop(); setState(STATE.SEALED); setQuery("");}}>
            <h2>Sealed</h2>
          </div>

          <div className={`footer-button-container ${state === STATE.PACK ? 'is-active' : ''}`} onClick={() => { goToTop(); setState(STATE.PACK); setQuery("");}}>
            <h2>Packs</h2>
          </div>
      
          <div className={`footer-button-container ${state === STATE.SINGLE ? 'is-active' : ''}`} onClick={() => { goToTop(); setState(STATE.SINGLE); setQuery("");}}>
            <h2>Singles</h2>
          </div>

          <div className={`footer-button-container ${state === STATE.SLAB ? 'is-active' : ''}`} onClick={() => { goToTop(); setState(STATE.SLAB); }}>
            <h2>Slabs</h2>
          </div>

          <div className={`footer-button-container ${state === STATE.PROMO ? 'is-active' : ''}`} onClick={() => { goToTop(); setState(STATE.PROMO); setQuery("");}}>
            <h2>Promo</h2>
          </div>

          <div className={`footer-button-container ${state === STATE.CART ? 'is-active' : ''}`}  onClick={() => { goToTop(); setState(STATE.CART); setQuery("");}}>
          {/* <h2>{getCartCount() > 0 ? getCartCount(): "Cart"}</h2> */}
            <img
              src={
                getCartCount() > 0
                  ? "/assets/imgs/shopping-cart-filled.png"
                  : "/assets/imgs/shopping-cart.png"
              }
              alt="cart"
            />
          </div>
          <div className={`footer-button-container ${state === STATE.PROFILE ? 'is-active' : ''}`} onClick={() => {toggleMenu()}}>
            <h2>MENU</h2>
            <button className={`footer-button`}
          >
          {/* <img src="/logo192.png" alt="Toggle" /> */}
        </button>
          </div>  
      </div>
      {!isAdminPage && (
        <div className="intro-container">
          <h1 className='title'>{getTitle(state)}</h1>
          <h2 className='subtitle'>{getDescription(state, user)}</h2>
        </div>
      )}
    </div>
  );
}



export default FooterComponent